import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Building2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { translateFr as tfr } from "@/i18n";

export default function EnterpriseModal({ open, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", organisation: "", team_size: "", org_type: "", sports: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.name.trim() || !form.email.includes("@")) {
      toast.error("Nom et email professionnel requis");
      return;
    }
    setSending(true);
    try {
      const r = await api.post("/billing/enterprise-lead", form);
      toast.success(r.data.message || tfr("Votre demande a bien été transmise."));
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossible d'envoyer la demande");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="enterprise-modal">
        <DialogTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5 text-orange-400" /> Athlynx Enterprise — {tfr("Nous contacter")}
        </DialogTitle>
        <DialogDescription>{tfr("Décrivez vos besoins, notre équipe revient vers vous rapidement.")}</DialogDescription>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mt-2">
          <Input placeholder="Nom *" value={form.name} onChange={set("name")} data-testid="ent-name" />
          <Input placeholder="Email professionnel *" type="email" value={form.email} onChange={set("email")} data-testid="ent-email" />
          <Input placeholder={tfr("Téléphone")} value={form.phone} onChange={set("phone")} data-testid="ent-phone" />
          <Input placeholder="Organisation" value={form.organisation} onChange={set("organisation")} data-testid="ent-org" />
          <Input placeholder={tfr("Taille de l'équipe")} value={form.team_size} onChange={set("team_size")} data-testid="ent-team" />
          <Input placeholder={tfr("Type (agence, club, fédération…)")} value={form.org_type} onChange={set("org_type")} data-testid="ent-type" />
          <Input placeholder="Sport(s) principal(aux)" value={form.sports} onChange={set("sports")} className="sm:col-span-2" data-testid="ent-sports" />
          <Textarea placeholder={tfr("Vos besoins principaux…")} rows={3} value={form.message} onChange={set("message")} className="sm:col-span-2 resize-none" data-testid="ent-message" />
        </div>
        <div className="flex justify-end gap-2 mt-3">
          <Button variant="ghost" onClick={onClose} data-testid="ent-cancel">{tfr("Annuler")}</Button>
          <Button onClick={submit} disabled={sending} className="gap-1.5" data-testid="ent-submit">
            {sending && <Loader2 className="h-4 w-4 animate-spin" />} Envoyer la demande
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
